<script>
export default {
  inheritAttrs: false,

  props: {
    rules: {
      type: Object,
      required: true,
    },

    id: {
      type: Number,
      required: true,
    },

    automation_rules: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    rule: null,
    value: null,
    option: null,
    loading: false,
    rule_value: null,
  }),

  watch: {
    rule (rule) {
      if (! rule) {
        this.value = null;
        this.options = null;
        this.rule_value = null;

        return;
      }

      this.loading = true;

      this.fetchRuleTypeValues(rule)
        .finally(() => this.loading = false);
    },
  },

  computed: {
    title () {
      if (this.selected) {
        return this.__(this.selected.name);
      }

      return this.__('Regras da campanha');
    },

    selected () {
      return this.mapped.find(({ key }) => this.rule == key);
    },

    mapped () {
      return Object
        .keys(this.rules)
        .map((key) => {
          const rule = this.rules[key];

          return {
            key,
            ...rule,
          };
        });
    },

    listeners () {
      const {
        save,
        ...listeners
      } = this.$listeners;

      return listeners;
    },

    showOptions () {
      const {
        values = [],
        options = false,
      } = this.rule_value || {};

      return options && values && values.length > 0;
    },

    placeholder () {
      const {
        placeholder = this.__('Opção / Valor'),
      } = this.rule_value.value_input || {};

      return placeholder;
    },

    _option () {
      if (this.showOptions) {
        return this.option;
      }

      return this.value;
    },
  },

  methods: {
    save () {
      this.$emit('save', {
        value: this.value,
        option: this.option,
        type: this.selected.key,
      });
    },

    handleOptionInput (event) {
      const option = event.target.value;

      if (this.showOptions) {
        this.option = option;

        return;
      }

      this.value = option;
    },

    async fetchRuleTypeValues (type) {
      try {
        const {
          data,
        } = await this.$http.get(`/automation/rule/value?type=${type}`);

        this.rule_value = data;
      } catch (e) {
        this.value = null;
        this.options = null;
        this.rule_value = null;

        Alert.error(this.__('Nenhuma opção encontrada.'));
      }
    },
  },
};
</script>

<template>
  <AutomationBuilderModal
    v-model="rule"
    :title="title"
    @save="save"
    :items="mapped"
    v-bind="$attrs"
    v-on="listeners"
    :button="__('Escolher regra')"
    :placeholder="__('Encontre uma regra')"
  >
    <div
      v-if="rule_value && selected && ! loading"
      class="row automation-builder-modal__row"
    >
      <div
        v-if="showOptions"
        class="col-md-12"
      >
        <div class="form-group">
          <label
            v-text="placeholder"
          />

          <select
            v-model="value"
            class="form-control"
          >
            <option
              :value="null"
            >
              {{ __('Selecione') }}
            </option>

            <option
              v-text="text"
              v-for="({ value, text }) in rule_value.values"
              :key="value"
              :value="value"
            />
          </select>
        </div>
      </div>

      <div
        class="col-md-12"
        v-if="rule_value.option_input"
      >
        <div class="form-group">
          <label
            v-text="rule_value.option_input.placeholder"
          />

          <input
            :value="_option"
            class="form-control"
            @input="handleOptionInput"
            :type="rule_value.option_input.type"
            :placeholder="rule_value.option_input.placeholder"
          >
        </div>
      </div>
    </div>
  </AutomationBuilderModal>
</template>
